import { useCallback } from "react";
import t from "../locales";
import { toBlob } from "html-to-image";

export default function ShareWidgetComponent({
  shareBoxRef,
  profile,
  isMobile,
  canShare,
}) {
  const encodeBase64 = btoa;
  const base64Profile = encodeBase64(JSON.stringify(profile));

  const urlToShare = `${window.location.host}/result?p=${base64Profile}`;

  const shareImage = useCallback(async () => {
    try {
      const blob = await toBlob(shareBoxRef.current, { cacheBust: true });
      const file = new File([blob], "resultaat.png", { type: blob.type });

      await navigator.share({
        files: [file],
      });
    } catch (err) {
      // Ignore errors if the user doesn't complete the sharing
      // Otherwise we re-throw
      if (err instanceof Error && err.name === "AbortError") return;
      throw err;
    }
  }, [shareBoxRef, urlToShare]);

  return (
    <>
      {canShare && isMobile ? (
        <button className="button button--center" onClick={shareImage}>
          {t("share.widget.mobile.button")}
        </button>
      ) : (
        <div className="widget">
          <span className="widget__text">{t("share.widget.desktop.text")}</span>
          <div className="widget__button-container">
            <div className="widget__link-container">
              <span className="widget__url">{urlToShare}</span>
            </div>
            <button
              type="button"
              onClick={() => {
                window.navigator.clipboard.writeText(urlToShare);
              }}
              className="button button--share widget__button"
            >
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 11C3.63333 11 3.31944 10.8695 3.05833 10.6084C2.79722 10.3473 2.66667 10.0334 2.66667 9.66671V1.66671C2.66667 1.30004 2.79722 0.986152 3.05833 0.725041C3.31944 0.46393 3.63333 0.333374 4 0.333374H10C10.3667 0.333374 10.6806 0.46393 10.9417 0.725041C11.2028 0.986152 11.3333 1.30004 11.3333 1.66671V9.66671C11.3333 10.0334 11.2028 10.3473 10.9417 10.6084C10.6806 10.8695 10.3667 11 10 11H4ZM4 9.66671H10V1.66671H4V9.66671ZM1.33333 13.6667C0.966667 13.6667 0.652778 13.5362 0.391667 13.275C0.130556 13.0139 0 12.7 0 12.3334V3.00004H1.33333V12.3334H8.66667V13.6667H1.33333Z"
                  fill="currentcolor"
                />
              </svg>
              {t("share.widget.desktop.button")}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
